/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CompleteDevicePlanChangeRequest,
  CreateDevicePlanChangeRequest,
  DeleteDevicePlanChangeRequest,
  DevicePlanChangeOnAzure,
} from '../models/index';
import {
    CompleteDevicePlanChangeRequestFromJSON,
    CompleteDevicePlanChangeRequestToJSON,
    CreateDevicePlanChangeRequestFromJSON,
    CreateDevicePlanChangeRequestToJSON,
    DeleteDevicePlanChangeRequestFromJSON,
    DeleteDevicePlanChangeRequestToJSON,
    DevicePlanChangeOnAzureFromJSON,
    DevicePlanChangeOnAzureToJSON,
} from '../models/index';

export interface ApiDevicePlanChangeCompleteDevicePlanChangeRequestPostRequest {
    completeDevicePlanChangeRequest?: CompleteDevicePlanChangeRequest;
}

export interface ApiDevicePlanChangeCreateDevicePlanChangeRequestPostRequest {
    createDevicePlanChangeRequest?: CreateDevicePlanChangeRequest;
}

export interface ApiDevicePlanChangeDeleteDevicePlanChangeRequestDeleteRequest {
    deleteDevicePlanChangeRequest?: DeleteDevicePlanChangeRequest;
}

export interface ApiDevicePlanChangeGetPendingRequestByMacAddressGetRequest {
    macAddress: string;
}

/**
 * 
 */
export class DevicePlanChangeApi extends runtime.BaseAPI {

    /**
     */
    async apiDevicePlanChangeCompleteDevicePlanChangeRequestPostRaw(requestParameters: ApiDevicePlanChangeCompleteDevicePlanChangeRequestPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevicePlanChangeOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/DevicePlanChange/CompleteDevicePlanChangeRequest`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompleteDevicePlanChangeRequestToJSON(requestParameters['completeDevicePlanChangeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevicePlanChangeOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiDevicePlanChangeCompleteDevicePlanChangeRequestPost(requestParameters: ApiDevicePlanChangeCompleteDevicePlanChangeRequestPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevicePlanChangeOnAzure> {
        const response = await this.apiDevicePlanChangeCompleteDevicePlanChangeRequestPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiDevicePlanChangeCreateDevicePlanChangeRequestPostRaw(requestParameters: ApiDevicePlanChangeCreateDevicePlanChangeRequestPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevicePlanChangeOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/DevicePlanChange/CreateDevicePlanChangeRequest`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDevicePlanChangeRequestToJSON(requestParameters['createDevicePlanChangeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevicePlanChangeOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiDevicePlanChangeCreateDevicePlanChangeRequestPost(requestParameters: ApiDevicePlanChangeCreateDevicePlanChangeRequestPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevicePlanChangeOnAzure> {
        const response = await this.apiDevicePlanChangeCreateDevicePlanChangeRequestPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiDevicePlanChangeDeleteDevicePlanChangeRequestDeleteRaw(requestParameters: ApiDevicePlanChangeDeleteDevicePlanChangeRequestDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/DevicePlanChange/DeleteDevicePlanChangeRequest`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteDevicePlanChangeRequestToJSON(requestParameters['deleteDevicePlanChangeRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDevicePlanChangeDeleteDevicePlanChangeRequestDelete(requestParameters: ApiDevicePlanChangeDeleteDevicePlanChangeRequestDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiDevicePlanChangeDeleteDevicePlanChangeRequestDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiDevicePlanChangeGetAllDevicePlanChangeRequestsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DevicePlanChangeOnAzure>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/DevicePlanChange/GetAllDevicePlanChangeRequests`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DevicePlanChangeOnAzureFromJSON));
    }

    /**
     */
    async apiDevicePlanChangeGetAllDevicePlanChangeRequestsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DevicePlanChangeOnAzure>> {
        const response = await this.apiDevicePlanChangeGetAllDevicePlanChangeRequestsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiDevicePlanChangeGetPendingRequestByMacAddressGetRaw(requestParameters: ApiDevicePlanChangeGetPendingRequestByMacAddressGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevicePlanChangeOnAzure>> {
        if (requestParameters['macAddress'] == null) {
            throw new runtime.RequiredError(
                'macAddress',
                'Required parameter "macAddress" was null or undefined when calling apiDevicePlanChangeGetPendingRequestByMacAddressGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['macAddress'] != null) {
            queryParameters['mac_address'] = requestParameters['macAddress'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/DevicePlanChange/GetPendingRequestByMacAddress`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevicePlanChangeOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiDevicePlanChangeGetPendingRequestByMacAddressGet(requestParameters: ApiDevicePlanChangeGetPendingRequestByMacAddressGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevicePlanChangeOnAzure> {
        const response = await this.apiDevicePlanChangeGetPendingRequestByMacAddressGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
